import React from 'react'

import NoticeBarContainer from 'APP/Components/NoticeBarContainer'
import { ResponsiveScrollView } from 'APP/Converse/Layout'

function SelfNavigationScreen() {
  return (
    <NoticeBarContainer>
      <ResponsiveScrollView />
    </NoticeBarContainer>
  )
}

export default SelfNavigationScreen
